export default {
  data() {
    return {
      inputType: 'text',
      inputTypeDef: {}
    }
  },
  methods: {

  }
}
